export interface Role {
    id?: number;
    name?: string;
    isAdministrator?: boolean;
    permissions?: Permission[];
    dataFilterGroups?: DataFilterGroup[];
}

export interface Permission {
    code: PermissionType;
    name: string;
    enabled: boolean;
}

export enum PermissionType {
    Options_read = 0,
    Options_write = 1,

    Sites_read = 2,
    Sites_write = 3,

    Channels_read = 4,
    Channels_write = 5,

    Demands_read = 6,
    Demands_write = 7,

    Relocations_read = 10,
    Relocations_write = 11,

    Products_read = 16,
    Products_write = 17,

    Stocks_read = 18,
    Stocks_write = 19,

    RelocationLimits_read = 22,
    RelocationLimits_write = 23,

    Rules_read = 26,
    Rules_write = 27,

    Vehicles_read = 28,
    Vehicles_write = 29,

    Teches_read = 30,
    Teches_write = 31,

    Indicators_read = 32,
    Indicators_write = 33,

    Replacements_read = 34,
    Replacements_write = 35,

    ResourceTypes_read = 38,
    ResourceTypes_write = 39,

    ResourceTypeRelations_read = 40,
    ResourceTypeRelations_write = 41,

    Cranes_read = 42,
    Cranes_write = 43,

    InactivityIntervals_read = 44,
    InactivityIntervals_write = 45,

    ActivitySchedules_read = 46,
    ActivitySchedules_write = 47,

    DayInactivityIntervals_read = 48,
    DayInactivityIntervals_write = 49,

    ReceptionLimits_read = 50,
    ReceptionLimits_write = 51,

    Resources_read = 52,
    Resources_write = 53,

    LocationHistory_read = 54,
    LocationHistory_write = 55
}

export interface DataFilterGroup {
    name?: string;
    filters?: DataFilter[];
}

export interface DataFilter {
    key?: string;
    value?: string;
    requirement?: string;
}
